<template>
	<div class="ReplacePwd">
		<el-form ref="loginForm" :model="changePwd" :rules="changePwdRules" class="from_box" autocomplete="on" label-width="80px" label-position="left">
		<div class="changePwd_title">
			修改密码
		</div>
        <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
          <el-form-item prop="oldPwd" class="input_box" label="原密码:">
            <el-input
              key="oldPwd"
              ref="password"
              v-model="changePwd.oldPwd"
              :type="passwordType[0]"
              :placeholder="$t('login.password')"
              maxlength="30"
              name="password"
              tabindex="2"
              autocomplete="on"
              @keyup.native="checkCapslock"
              @blur="capsTooltip = false"
            />
            <span class="show-pwd" @click="()=>{showPwd(0)}">
              <svg-icon :icon-class="passwordType[0] === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>
        </el-tooltip>

        <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
          <el-form-item prop="newPwd" class="input_box" label="新密码:">
            <el-input
              key="newPwd"
              ref="password"
              v-model="changePwd.newPwd"
              :type="passwordType[1]"
              :placeholder="$t('login.password')"
              maxlength="30"
              name="password"
              tabindex="2"
              autocomplete="on"
              @keyup.native="checkCapslock"
              @blur="capsTooltip = false"
            />
            <span class="show-pwd" @click="()=>{showPwd(1)}">
              <svg-icon :icon-class="passwordType[1] === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>
        </el-tooltip>

        <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
          <el-form-item prop="repeatPwd" class="input_box" label="确认密码:">
            <el-input
              key="repeatPwd"
              ref="password"
              v-model="changePwd.repeatPwd"
              :type="passwordType[2]"
              :placeholder="$t('login.password')"
              maxlength="30"
              name="password"
              tabindex="2"
              autocomplete="on"
              @keyup.native="checkCapslock"
              @blur="capsTooltip = false"
              @keyup.enter.native="onSubmit"
            />
            <span class="show-pwd" @click="()=>{showPwd(2)}">
              <svg-icon :icon-class="passwordType[2] === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>
        </el-tooltip>
        <div style="text-align: right; padding-right: 25px;">
          <el-button @click.native.prevent="cancel">
          	取消
          </el-button>
          <el-button :loading="loading" type="primary" @click.native.prevent="onSubmit">
            完成
          </el-button>
        </div>
      </el-form>

	</div>
</template>

<script type="text/javascript">
import { Encrypt } from "@/utils/crypto";

export default{
	name: "ReplacePwd",
	data() {
		const validatePassword = (rule, value, callback) => {
	      if (!value) {
	        callback(new Error('请输入正确的密码'))
	      } else {
	        callback()
	      }
	    }
    const checkRepeatPwd = (rule, value, callback) => {
      if(value !== this.changePwd.newPwd){
        console.log(value);
        console.log(this.changePwd.newPwd);
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changePwd.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
		return {
			changePwd: {
				oldPwd: '',
				newPwd: '',
				repeatPwd: '',
			},
			changePwdRules: {
				oldPwd: [{ required: true, trigger: 'blur', validator: validatePassword }],
				newPwd: [{ required: true, trigger: 'blur', validator: validatePassword }],
				repeatPwd: [{ required: true, trigger: 'blur', validator: validatePass2 }],
			},
			passwordType: new Array(3).fill("password"),
      // 按钮loading 状态
      loading: false,
		}
	},
	methods: {
    // 检查大小写状态
		checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && (key >= 'A' && key <= 'Z')
    },
    // 显示密码
		showPwd(index) {
      let temp = [...this.passwordType];
		  if (temp[index] === 'password') {
		    temp[index] = ''
		  } else {
		    temp[index] = 'password'
		  }
      this.passwordType = temp;
		  // this.$nextTick(() => {
		  //   this.$refs.password.focus()
		  // })
		},
    // 提交密码修改
    onSubmit() {
      if(this.loading) return false;
      // this.$refs.baseinfo.validate(valid => {
      // })
      // let resex2 = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,20}$/;

      if (!this.changePwd.oldPwd || !this.changePwd.newPwd || !this.changePwd.repeatPwd) {
        this.$message.error('必填字段不能为空!')
        return false
      }

      // if (!resex2.test(this.changePwd.oldPwd) || !resex2.test(this.changePwd.newPwd)) {
      //   this.$message.error('密码需包含写字母特殊符号数字且不少于8位!')
      //   return false
      // }
      if (this.changePwd.repeatPwd != this.changePwd.newPwd) {
        this.$message.error('两次输入密码须一致!')
        return false
      }
      // if (this.changePwd.oldPwd == this.changePwd.newPwd || this.changePwd.oldPwd == this.changePwd.repeatPwd ) {
      //   this.$message.error('原密码和新密码不能相同!')
      //   return false
      // }

      this.loading = true;
      // 修改密码
      this.$api.personUpdatePassword({
        newPassword: Encrypt(this.changePwd.newPwd),
        oldPassword: Encrypt(this.changePwd.oldPwd),
      }).then(res => {
        if(res.errcode != 0){
          console.log(res);
          this.loading = false;
          return false;
        }
        let code = res.errcode 
        if (code == 0) {
          this.$message.success(res.errmsg)
          this.changePwd = {
            oldPwd: '',
            newPwd: '',
            repeatPwd: '',}
          this.loading = false;
          // this.$store.dispatch('user/logout');
          this.$emit("handleDone");

          this.$store.dispatch('user/setToken', {
              access_token: res.data.access_token,
              refresh_token: res.data.refresh_token
          })
          this.$router.push({ path: this.redirect || '/', query: this.otherQuery }).catch(err => {})
        }
      }).catch((error)=>{
        console.log(error);
      })
    },

    // 取消事件
    cancel(){
      this.$emit("cancel");
    }
	}
}

</script>

<style lang="scss" scoped>
  .ReplacePwd{
    height: 100%;
  }
  .input_box{
    background: #FFFFFF;
    border-radius: 4px;
  }
  .el-input{
  	width: calc(100% - 25px);
    border-radius: 5px;
  	height: 36px;
  	// border: 1px solid #d8d8d8;
  	box-shadow: none;
  	// input {
  	// 	height: 36px;

  	// }
  }
  .el-form-item {
    // border: 1px solid rgba(255, 255, 255, 0.1);
    background: white;
    border-radius: 5px;
    color: #454545;
  }
  .show-pwd {
  	margin-left: 10px;
    cursor: pointer;
  }
  .changePwd_title{
  	font-size: 22px;
  	color: #3C4353;
	margin: 0px auto 10px auto;
	text-align: left;
	font-weight: bold;
  }
</style>